import { computed } from 'mobx';
import FileModel    from './globals/FileModel';

export default class MountingAttestationMediaModel extends FileModel {
    static get path() {
        return '/backend/mounting_attestation_media/{?id}';
    }

    @computed
    get mediaFileName(): string {
        return this.get('mediaFileName');
    }

    @computed
    get objectUrl(): string {
        return this.get('objectUrl');
    }
}